import { Themes, special, normal } from './'

import { PluginObject } from 'vue'

import type { ThemePlugin } from '@/@types/theme'

export const Theme: PluginObject<ThemePlugin> = {
  install: function (Vue, _options) {
    Vue.prototype.$theme = Vue.observable({
      isSpecial: (<Themes>localStorage.getItem('vologda.cabinet.client.theme') || Themes.Normal) === Themes.Special,
      name: <Themes>localStorage.getItem('vologda.cabinet.client.theme') || Themes.Normal,
    })

    // Необходимо вызвать 1 раз без аргумента для инициализации (как можно раньше)
    Vue.prototype.$initTheme = function () {
      const theme = <Themes>localStorage.getItem('vologda.cabinet.client.theme') || Themes.Normal
      this.$vuetify.theme.themes.light = theme === Themes.Special ? { ...special } : { ...normal }
    }

    Vue.prototype.$setTheme = function (name: Themes) {
      this.$theme.isSpecial = name === Themes.Special
      this.$theme.name = name
      localStorage.setItem('vologda.cabinet.client.theme', name)
      this.$vuetify.theme.themes.light = name === Themes.Special ? { ...special } : { ...normal }
    }
  },
}
